import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { dashboardStatsQuery, forViewer, viewerIdOf } from "../services/queries";

export { DASHBOARD_QUERY_KEY } from "../services/queries";

export const useDashboardData = (month?: string) => {
  const { user, token } = useAuth();

  return useQuery({
    ...forViewer(dashboardStatsQuery(user?.schoolId, token, month), viewerIdOf(user)),
    enabled: !!user?.schoolId && !!token,
  });
};
